import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AllotmentCodePage } from './allotment-code.page';

const routes: Routes = [
  { path: '', component: AllotmentCodePage },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AllotmentCodeRoutingModule { }
